import AdminNexusHttpClient from './admin-nexus-http-client'
import PagedResult from '../models/paged-result'

export default class ExtrasService {
  constructor() {
    this.httpClient = new AdminNexusHttpClient('/admin/extras')
  }

  async list(propertyId, page = 1, pageSize = 10, term = '') {
    const response = await this.httpClient.get('', {
      propertyId,
      page,
      pageSize,
      term,
    })
    let result = new PagedResult()
    if (response && response.items) {
      result.total = response.total
      result.items = response.items
    }
    return result
  }

  async forProperty(id) {
    return await this.httpClient.get(`by-property/${id}`)
  }

  async get(id) {
    return await this.httpClient.get(`${id}`)
  }

  async add(payload) {
    return await this.httpClient.put(``, payload)
  }

  async update(payload) {
    return await this.httpClient.post(``, payload)
  }

  async delete(id) {
    return await this.httpClient.delete(`${id}`)
  }
}
